export default __webpack_public_path__ + "static/media/games_bg.caf72481.png";